import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import StyledBoxButton from './BoxButton.style';
// import './BoxButton.css';

const BoxButton = ({
  href,
  header,
  subheader,
  description,
  external,
  icon,
  iconBG,
  qa,
  onClick,
  theme
}) => {
  const boxCSS = cn(
    'boxbutton',
    theme ? theme.map(css => `boxbutton--${css}`).join(' ') : ''
  );
  return (
    <StyledBoxButton className={boxCSS} {...qa}>
      <div className="boxbutton__inner">
        {icon && (
          <i
            className="icon"
            style={iconBG && { backgroundImage: `url(${iconBG})` }}
          >
            {icon}
          </i>
        )}
        <div className="boxbutton__content">
          <header>
            {header && <Header as="h2">{header}</Header>}
            {subheader && <Header as="h3">{subheader}</Header>}
          </header>
          {description}
        </div>
      </div>
      {external ? (
        <a
          href={href}
          onClick={onClick}
          title={header}
          target="agi"
          className="boxbutton__cover"
        >
          {header}
        </a>
      ) : (
        <Link
          to={href}
          onClick={onClick}
          title={header}
          className="boxbutton__cover"
        >
          {header}
        </Link>
      )}
    </StyledBoxButton>
  );
};

BoxButton.propTypes = {
  href: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.string,
  description: PropTypes.node,
  icon: PropTypes.node,
  iconBG: PropTypes.string,
  external: PropTypes.bool,
  qa: PropTypes.object,
  onClick: PropTypes.func,
  theme: PropTypes.array
};

BoxButton.defaultProps = {
  external: false
};

export default BoxButton;



// WEBPACK FOOTER //
// ./src/components/BoxButton/BoxButton.js